<template>
  <v-container pa-0>
    <v-row>
      <v-col cols="12" class="pt-0">
        <div class="v-label">{{ label }}</div>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" lg="6">
        <v-text-field
          label="Address 1"
          v-model="question.value.street1"
          filled
          dense
          :disabled="disabled"
          :rules="[rules.condRequired(null, required)]"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" lg="6">
        <v-text-field
          label="Suite, APT (optional)"
          v-model="question.value.street2"
          filled
          dense
          :disabled="disabled"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="8" lg="4">
        <v-text-field
          class="mr-sm-4"
          label="City"
          v-model="question.value.city"
          filled
          dense
          :disabled="disabled"
          :rules="[rules.condRequired(null, required)]"
        >
        </v-text-field>
      </v-col>
      <v-col cols="12" sm="4" lg="2">
        <v-autocomplete
          label="State"
          :items="states"
          v-model="question.value.state"
          item-value="state"
          item-text="code"
          filled
          dense
          clearable
          :disabled="disabled"
          :rules="[rules.condRequired(null, required)]"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" lg="4">
        <v-text-field
          label="Zip Code"
          v-model="question.value.postalCode"
          filled
          dense
          class="mr-sm-4"
          :disabled="disabled"
          :rules="[rules.zip, rules.condRequired(null, required)]"
        >
        </v-text-field>
      </v-col>
    </v-row>
    <v-row no-gutters>
      <v-col cols="12" sm="6" lg="6">
        <v-autocomplete
          label="Country"
          :items="countries"
          v-model="question.value.country"
          item-value="code"
          item-text="name"
          filled
          dense
          clearable
          :disabled="disabled"
          :rules="[rules.condRequired(null, required)]"
        >
        </v-autocomplete>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import QuestionMixin from "./QuestionMixin";
import hasConstant from "@/mixins/has-constant";
import * as rules from "@/services/rules";

export default {
  name: "AddressQuestion",
  mixins: [QuestionMixin, hasConstant],
  data: function() {
    return {
      rules
    };
  },
  created: function() {
    if (!this.question.value) this.question.value = {};
    if (!this.question.value.country) this.question.value.country = "US";
  }
};
</script>
<style lang="sass" scoped></style>
